import React from 'react';
import { moduleApi } from '../../../lib/api';
import { Guest, guestAllergies, guestRestrictions } from '../../Evenementiel/convives/guestFilters';

export interface ConvivesStats {
    total: number;
    invites: number;
    reponses: number;
    /** Invités qui n'ont pas répondu — ceux que l'on relance. */
    silencieux: number;
    /** Convives ayant déclaré au moins une allergie ou une restriction. */
    contraintes: number;
}

export const statsConvives = (guests: Guest[]): ConvivesStats => ({
    total: guests.length,
    invites: guests.filter((g) => !!g.invitation_sent_at).length,
    reponses: guests.filter((g) => !!g.responded_at).length,
    silencieux: guests.filter((g) => g.invitation_sent_at && !g.responded_at).length,
    contraintes: guests.filter((g) => guestAllergies(g).length > 0 || guestRestrictions(g).length > 0).length,
});

/**
 * Les chiffres de Menus & Convives, LUS depuis la liste des convives de la privatisation — jamais
 * recalculés ni stockés sur le dossier (même principe que `collecte_status` : on reflète, on ne
 * reduplique pas). `null` tant que la privatisation n'existe pas, ou si le module Menus & Convives
 * n'est pas activé pour cet établissement (le serveur refuse alors la route : ce n'est pas une erreur,
 * simplement il n'y a rien à compter).
 */
export function useDossierConvives(eventId?: string | null): ConvivesStats | null {
    const [stats, setStats] = React.useState<ConvivesStats | null>(null);
    React.useEffect(() => {
        if (!eventId) { setStats(null); return; }
        let annule = false;
        moduleApi.getEvenementielGuests(eventId)
            .then((g: any) => { if (!annule) setStats(statsConvives(Array.isArray(g) ? g : [])); })
            .catch(() => { if (!annule) setStats(null); });
        return () => { annule = true; };
    }, [eventId]);
    return stats;
}
